import React from "react";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hitGetSettingsApi } from "../../../Redux/Common/GetSettingsSlice";

const TermService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [text, setText] = React.useState("");
  useEffect(() => {
    dispatch(hitGetSettingsApi()).then((response) => {
      if (response.payload && response.payload.status === true) {
        setText(response.payload.data.termsOfServiceText);
      }
    });
  }, [dispatch, navigate]);

  return (
    <>
      <div className="PrivacyPolicy-container">
        <div className="custom_container">
          <div
            className="warning-card pt-4 pt-md-5"
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default TermService;
